/**
 * Helper: Login-URL oeffnen & Login automatisch in die Zwischenablage legen.
 *
 * Wird vom „Einmal-Klick zum Login"-Button auf den IT-Zugang-Karten
 * (Mein Profil + Mitarbeiterformular) verwendet.
 */
import { toast } from 'sonner';

export const openLoginAndCopy = async ({ url, login, password, copyPassword = false }) => {
  if (!url) {
    toast.error('Keine Login-URL hinterlegt');
    return;
  }

  // Best-effort copy. window.open MUSS direkt im User-Click-Handler stehen,
  // sonst blockt der Browser den Pop-up. Deshalb erst Tab oeffnen, dann clipboard.
  const win = window.open(url, '_blank', 'noopener,noreferrer');
  if (!win) {
    toast.error('Pop-up blockiert. Bitte URL manuell oeffnen.');
    return;
  }

  const target = copyPassword ? password : login;
  const targetLabel = copyPassword ? 'Passwort' : 'Login';

  if (!target) {
    toast.success(`Seite geoeffnet (kein ${targetLabel} hinterlegt)`);
    return;
  }

  try {
    await navigator.clipboard?.writeText(target);
    toast.success(`${targetLabel} kopiert — beim Anmelden einfach einfuegen`);
  } catch {
    toast.warning('Seite geoeffnet, aber Zwischenablage nicht erreichbar');
  }
};
